import { Nillable } from '@web/utils';
import {
  DictionaryCountry,
  PhoneNumberWithPrefix,
} from '@web/shared/module/dictionary';

export class PublicOrderShippingAddress {
  public constructor(
    private readonly data: {
      city: string;
      dignity: string;
      email: string;
      firstName: string;
      lastName: string;
      phone: PhoneNumberWithPrefix;
      postCode: string;
      streetLine1: string;
      country: DictionaryCountry;
      streetLine2?: Nillable<string>;
      state?: Nillable<string>;
      companyName?: Nillable<string>;
      shippingPointName?: Nillable<string>;
      shippingPoint?: Nillable<string>;
    },
  ) {}

  public get city(): string {
    return this.data.city;
  }

  public get dignity(): string {
    return this.data.dignity;
  }

  public get email(): string {
    return this.data.email;
  }

  public get firstName(): string {
    return this.data.firstName;
  }

  public get lastName(): string {
    return this.data.lastName;
  }

  public get phone(): PhoneNumberWithPrefix {
    return this.data.phone;
  }

  public get postCode(): string {
    return this.data.postCode;
  }

  public get streetLine1(): string {
    return this.data.streetLine1;
  }

  public get country(): DictionaryCountry {
    return this.data.country;
  }

  public get streetLine2(): Nillable<string> {
    return this.data.streetLine2;
  }

  public get state(): Nillable<string> {
    return this.data.state;
  }

  public get companyName(): Nillable<string> {
    return this.data.companyName;
  }

  public get asString(): string {
    return [
      this.streetLine1,
      this.streetLine2,
      this.postCode,
      this.state,
      this.city,
      `${this.country.label} (${this.country.isoCode})`,
    ]
      .filter(Boolean)
      .join(', ');
  }

  public get shippingPointName(): Nillable<string> {
    return this.data.shippingPointName;
  }

  public get shippingPoint(): Nillable<string> {
    return this.data.shippingPoint;
  }
}
